"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
require("./clusterApi");
const clusterEndpointKeys_1 = require("./clusterEndpointKeys");
const request_1 = __importDefault(require("@hotmart/request"));
class ClusterService {
}
_a = ClusterService;
ClusterService.get = async () => {
    return await (0, request_1.default)(clusterEndpointKeys_1.ClusterEndpointKeys.GetCluster);
};
exports.default = ClusterService;
